import {
    AutocompleteInput,
    Edit,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Layers, Package } from 'lucide-react';
import { required } from 'ra-core';
import { BoMItemsTable } from './BoMItemsTable';

export const BoMEdit = () => {
    return (
        <Edit>
            <SimpleForm className="max-w-5xl mx-auto space-y-6">
                <Card className="w-full shadow-sm">
                    <CardHeader className="pb-3 border-b bg-slate-50/50">
                        <div className="flex items-center gap-2">
                            <Layers className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Edit Bill of Materials</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <TextInput source="reference" label="BoM Reference" validate={required()} className="w-full font-mono" />
                            
                            <ReferenceInput source="project_id" reference="projects">
                                <AutocompleteInput label="Project" validate={required()} className="w-full" />
                            </ReferenceInput>

                            <ReferenceInput source="design_request_id" reference="design_requests">
                                <AutocompleteInput label="Design Request" className="w-full" />
                            </ReferenceInput>

                            <SelectInput 
                                source="status" 
                                label="Status" 
                                choices={[
                                    { id: 'draft', name: 'Draft' },
                                    { id: 'approved', name: 'Approved' },
                                    { id: 'superseded', name: 'Superseded' },
                                    { id: 'cancelled', name: 'Cancelled' },
                                ]}
                                className="w-full"
                            />
                        </div>
                    </CardContent>
                </Card>

                <Card className="w-full shadow-sm border-t-4 border-t-slate-900">
                    <CardHeader className="pb-3 border-b">
                        <div className="flex items-center gap-2">
                            <Package className="w-5 h-5 text-slate-500" />
                            <CardTitle className="text-lg font-semibold tracking-tight">Material Breakdown</CardTitle>
                        </div>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-6">
                        <BoMItemsTable />
                        
                        <div className="flex justify-end pt-4 border-t">
                            <div className="bg-slate-50 p-4 rounded-lg border flex items-center gap-4">
                                <span className="text-xs font-bold uppercase tracking-widest text-slate-500">Total Estimated Cost (₹)</span>
                                <NumberInput source="total_estimated_cost" label={false} readOnly className="font-bold text-xl text-blue-600" />
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </SimpleForm>
        </Edit>
    );
};
